import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { SubscriptionEnvironment } from './environment';
import { IngressSubscription, IngressLineItemPrice } from './ingress';

export class SubscriptionRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(SubscriptionEnvironment).url, session, { authorizationSession: true });
  }

  public createSubscription = (plan: string, trial: boolean, coupon?: string): SafePromise<IngressSubscription> => {
    const url = this.URL('api/v1/subscriptions/');
    return this.post(url, {
      coupon: coupon || null,
      plan,
      trial,
    });
  };

  public getSubscriptions = (): SafePromise<IngressSubscription[]> => {
    const url = this.URL('api/v1/subscriptions/');
    return this.get(url);
  };

  public updateSubscription = (
    uuid: string,
    selectedPlan: string,
    card?: string,
    coupon?: string,
    isFeatureUpdate?: boolean,
  ): SafePromise<IngressLineItemPrice> => {
    const url = this.URL(`api/v1/subscriptions/${uuid}/upgrade?next=${window.location.href}`);
    const body = {};
    if (card) {
      body['card'] = card;
    }
    if (coupon) {
      body['coupon'] = coupon;
    }
    if (isFeatureUpdate) {
      body['new_line_items'] = selectedPlan;
    } else {
      body['new_plan'] = selectedPlan;
    }
    return this.post(url, body);
  };

  public deleteSubscription = (uuid: string): SafePromise<any> => {
    const url = this.URL(`api/v1/subscriptions/${uuid}/`);
    return this.delete(url);
  };

  public restartSubscription = (uuid: string): SafePromise<any> => {
    const url = this.URL(`api/v1/subscriptions/${uuid}/uncancel`);
    return this.post(url);
  };
}
